export default "__VITE_ASSET__BTbNCOwl__"